/* =============================================================================
   Eterno Grafiche — Catalogo Grafiche: filtro categoria client-side
   ============================================================================= */

(function () {
  'use strict';

  const filters = document.querySelectorAll('.grf__filter');
  const items   = document.querySelectorAll('.grf__item');
  const empty   = document.getElementById('grf-empty');

  if (!filters.length || !items.length) return;

  filters.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var filter = btn.dataset.filter;

      // Aggiorna stato attivo sui bottoni
      filters.forEach(function (b) {
        b.classList.toggle('grf__filter--active', b === btn);
      });

      // Mostra/nascondi card
      var visible = 0;
      items.forEach(function (item) {
        var match = filter === 'all' || item.dataset.cat === filter;
        item.hidden = !match;
        if (match) visible++;
      });

      // Empty state
      if (empty) empty.hidden = visible > 0;
    });
  });

})();
